import { render, staticRenderFns } from "./StatementList.vue?vue&type=template&id=18764056&scoped=true&"
import script from "./StatementList.vue?vue&type=script&lang=ts&"
export * from "./StatementList.vue?vue&type=script&lang=ts&"
import style0 from "./StatementList.vue?vue&type=style&index=0&id=18764056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18764056",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
